import React, { useRef, useState } from 'react';
import { ArrowRight } from 'lucide-react';

// onUnavailable: sign-ups aren't stored yet, so the page explains that instead of faking success
export const AlertsSignupStrip = ({ onUnavailable }) => {
  const [contact, setContact] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!contact.trim()) {
      inputRef.current?.focus();
      return;
    }
    onUnavailable('IPO alert sign-ups are coming soon. Your details were not saved.');
  };

  return (
    <section
      aria-labelledby="dashboard-alerts-heading"
      className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-5 sm:p-6"
    >
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-5">
        <div>
          <p className="flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wider text-emerald-600">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
            Never Miss an Issue
          </p>
          <h2 id="dashboard-alerts-heading" className="mt-1 text-lg sm:text-xl font-extrabold text-slate-900 tracking-tight">
            Get Instant IPO Alerts, GMP Signals &amp; Allotment Status
          </h2>
          <p className="mt-1 text-xs sm:text-sm text-slate-500">
            Join 280,000+ investors receiving curated IPO updates directly on WhatsApp and Email.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto lg:min-w-[440px]">
          <label htmlFor="dashboard-alerts-contact" className="sr-only">
            WhatsApp number or email
          </label>
          <input
            id="dashboard-alerts-contact"
            ref={inputRef}
            type="text"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            placeholder="Enter WhatsApp No. or Email"
            className="flex-1 min-w-0 px-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#008080] focus:ring-1 focus:ring-[#008080]"
          />
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-xl bg-[#008080] hover:bg-[#006666] text-white text-sm font-bold transition-colors"
          >
            Subscribe Free
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </section>
  );
};

export default AlertsSignupStrip;
